<template>
<aside
    v-if="visible && connectivityStatus.mode === CONNECTIVITY_MODES.ONLINE && connectivityStatus.backendAvailable === true"
    class="continuity-banner"
    role="status"
  >
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>EWU continúa funcionando online. La continuidad sin conexión no está disponible porque el servidor local de respaldo no está preparado.</span>
  </aside>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {
  CONNECTIVITY_MODES,
  connectivityStatus,
} from '@/services/connectivity/connectivityService';

const WARNING_VISIBLE_MS = 5000;
const store = useStore();
const route = useRoute();
const visible = ref(false);
const warningCandidate = computed(() => {
  const state = store.state.device;
  if (store.state.operationalMode?.mode === 'LOCAL_MODE') return false;
  return Boolean(route.meta?.partnerMenu || route.meta?.tpvHub)
    && state.continuityPolicy === 'HYBRID_CLOUD_FIRST'
    && state.operationalAccessAllowed
    && connectivityStatus.mode === CONNECTIVITY_MODES.ONLINE
    && connectivityStatus.backendAvailable === true
    && state.localHub?.configured === true
    && Boolean(state.localHub?.effective_status)
    && state.localHub?.effective_status !== 'HUB_SHADOW_READY';
});

let warningTimer = null;

function clearWarningTimer() {
  if (warningTimer !== null) {
    window.clearTimeout(warningTimer);
    warningTimer = null;
  }
}

watch(warningCandidate, (shouldWarn) => {
  clearWarningTimer();

  if (!shouldWarn) {
    visible.value = false;
    return;
  }

  // El estado persistente se muestra en el header; este aviso solo informa
  // del cambio puntual y desaparece para no ocupar la pantalla.
  visible.value = true;
  warningTimer = window.setTimeout(() => {
    warningTimer = null;
    visible.value = false;
  }, WARNING_VISIBLE_MS);
}, { immediate: true });

onBeforeUnmount(clearWarningTimer);
</script>

<style scoped>
.continuity-banner { position: relative; z-index: 1; width: min(760px, calc(100% - 24px)); box-sizing: border-box; display: flex; gap: 10px; align-items: center; margin: 8px auto; padding: 12px 16px; border: 1px solid #f59e0b; border-radius: 14px; background: #fffbeb; color: #92400e; box-shadow: 0 8px 22px rgba(15,23,42,.12); font-weight: 700; }
</style>
